import { useEffect, useState } from "react";
import { Leaf } from "lucide-react";
import { CHECKOUT_URL } from "@/constants/checkout";

const links = [
  { label: "O Método", href: "#metodo", id: "nav-link-metodo" },
  { label: "Capítulos", href: "#capitulos", id: "nav-link-capitulos" },
  { label: "Autora", href: "#autora", id: "nav-link-autora" },
  { label: "FAQ", href: "#faq", id: "nav-link-faq" },
];

const scrollTo = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -108 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [left, setLeft] = useState("00:00:00");

  useEffect(() => {
    const tick = () => {
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      const diff = Math.max(0, end.getTime() - Date.now());
      const h = String(Math.floor(diff / 3.6e6)).padStart(2, "0");
      const m = String(Math.floor((diff % 3.6e6) / 6e4)).padStart(2, "0");
      const s = String(Math.floor((diff % 6e4) / 1000)).padStart(2, "0");
      setLeft(`${h}:${m}:${s}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header data-testid="navbar" className="sticky top-0 z-50">
      <div
        data-testid="urgency-bar"
        className="flex h-9 items-center justify-center gap-2 bg-terracotta px-4 text-cream"
      >
        <span className="relative flex h-2 w-2 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cream opacity-60" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-cream" />
        </span>
        <p className="truncate text-[11px] font-semibold uppercase tracking-wider sm:text-xs">
          Oferta de lançamento por <span className="font-bold">R$ 29,90</span> termina em
        </p>
        <span
          data-testid="urgency-countdown"
          className="rounded-md bg-ink/25 px-2 py-0.5 font-mono text-[11px] font-bold tabular-nums sm:text-xs"
        >
          {left}
        </span>
      </div>
      <div className="border-b border-linen bg-cream/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a
          href="#topo"
          onClick={(e) => scrollTo(e, "#topo")}
          data-testid="nav-logo"
          className="flex items-center gap-2"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest text-cream">
            <Leaf size={17} strokeWidth={2.2} />
          </span>
          <span className="font-serif text-lg font-semibold tracking-tight text-ink">
            Zero ao <span className="italic text-terracotta">Equilíbrio</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              onClick={(e) => scrollTo(e, l.href)}
              className="text-sm font-medium text-moss transition-colors hover:text-forest"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-button"
          className="cta-shine rounded-full bg-terracotta px-5 py-2.5 text-sm font-semibold text-cream transition-transform duration-300 hover:-translate-y-0.5"
        >
          Quero meu e-book
        </a>
      </div>
      </div>
    </header>
  );
}
